import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

export const firebaseConfig = {
  apiKey: "AIzaSyCvVqZhFv-Hb2EvxsA4fLveBZUpUqxyrPg",
  authDomain: "southern-list-468215-m7.firebaseapp.com",
  projectId: "southern-list-468215-m7",
  storageBucket: "southern-list-468215-m7.firebasestorage.app",
  messagingSenderId: "837393457967",
  appId: "1:837393457967:web:e9f3c5a8cdf16a618cb7da",
  measurementId: "G-3QT6YCW3PG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Google Analytics (auto-tracks page views, sessions, devices, location)
isSupported().then((supported) => {
  if (supported) getAnalytics(app);
});

export default app;
